import { render, staticRenderFns } from "./PowerBIViewCrudData.vue?vue&type=template&id=30a1b486"
import script from "./PowerBIViewCrudData.vue?vue&type=script&lang=js"
export * from "./PowerBIViewCrudData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports